// worker code has to be valid ES5
const statsCode = `

var notIE = !(~navigator.userAgent.indexOf('MSIE')) && !(~navigator.userAgent.indexOf('Trident/')) && !(~navigator.userAgent.indexOf('Edge')) 
var getNow = notIE ? function () {
	return performance.now()
} : Date.now


var self = this
var isActive = false
// frames to ignore
var framesToSkip = 12
var skipCounter = 0
var decodingLatencyIdentifiedCounter = 0
var decodingLatencyThreshold = 60 // in millisecond
var videoScaleFactor = 1.0

// variant length
var nalu_recv_series = []
// fixed length
var series_max_length = 16
var decoding_estimate_series = [] 
var image_series = []
var xhr

//////////////////////////////////
// utils functions
//////////////////////////////////

function computeMean(vector1D) {
	var sum = 0
	var len = vector1D.length
	for (var i = 0; i < len; i++) {
		sum += vector1D[i]
	}
	
	return sum / len
}

function computeVariance(vector1D, mean) {
	var sum = 0
	var len = vector1D.length
	for (var i = 0; i < len; i++) {
		sum += (vector1D[i] - mean) * (vector1D[i] - mean)
	}
	
	return sum / len
}

function computeCovariance1D(vector1D, mean_x, mean_y) {
	var len = vector1D.length

	var sum = 0
	for (var i = 0; i < len; i++) {
		sum += (i - mean_x) * (vector1D[i] - mean_y)
	}
	
	return sum / len
}

///////////////////////////////////////
// the main message handler
///////////////////////////////////////

self.onmessage = function (ev) {
	var command = ev.data.command 
	var now = getNow()
	
	switch (command) {
		case 'RECEIVE_NALU':
			if (isActive) {
				skipCounter++
				if (skipCounter > framesToSkip) {
					nalu_recv_series.push([now, ev.data.payload.inbound_size])
				}
			}
			break
		case 'DRAW_VIDEO_FRAME':
			if (isActive) {
				if (nalu_recv_series.length === 0) {
					return
				}
				
				var head = nalu_recv_series[0]
				var estimate_time = now - head[0]
				if (decoding_estimate_series.length === series_max_length) {
					decoding_estimate_series.shift()
				}
				decoding_estimate_series.push([estimate_time, head[1]])
				nalu_recv_series.shift()
				
				if (decoding_estimate_series.length === series_max_length) {
					analyseDecodingLatency()
				}
			}
			
			break
		case 'RECEIVE_IMAGE':
			break
			
		case 'DECODER_START':
			videoScaleFactor = ev.data.payload.scaleFactor
			isActive = true
			reset()
			break
		
		case 'IMG_ARRIVAL':

			break

		case 'IMG_ARRIVAL_END':

			break
		
		case 'CLOSE':
			self.close()
			break
	}
}

function analyseDecodingLatency() {
	var decodingLatencyVecor = decoding_estimate_series.map(function(item) {
		return item[0]
	})
	
	var n = decodingLatencyVecor.length
	
	var meanTime = computeMean(decodingLatencyVecor)
	
	var sumOrdinal = 0
	var meanOrdinal = (n - 1) / 2 
	for (var i = 0; i < n; i++) {
		sumOrdinal += (i - meanOrdinal) * (i - meanOrdinal)
	}
	var varianceOrdinal = sumOrdinal / n
	
	var covariance = computeCovariance1D(decodingLatencyVecor, meanOrdinal, meanTime)
	var slope = covariance / varianceOrdinal 

	// console.log('mean: ' + meanTime.toFixed(2) + '-- slope: ' + slope.toFixed(2))
	
	if (meanTime > decodingLatencyThreshold && (-1 < slope && slope < 1)) {
		decodingLatencyIdentifiedCounter++;
	}
	
	if (lagConditionSatisfied()) {
		self.postMessage({status: 'DECODING_LAG'})
		isActive = false
	}
}

function lagConditionSatisfied() {
	return decodingLatencyIdentifiedCounter > 3
}

function reset() {
	skipCounter = 0
	decodingLatencyIdentifiedCounter = 0
	nalu_recv_series = []
	decoding_estimate_series = []
}

`

export default statsCode